<template>
  <div class="layout-container">
    <!-- 二级路由出口 -->
    <router-view />
    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div 
        v-for="item in navItems" 
        :key="item.path"
        class="nav-item" 
        :class="{ active: isActive(item.path) }"
        @click="navigateTo(item.path)"
      >
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      navItems: [
        { path: '/home', label: '首页', icon: 'fas fa-house' },
        { path: '/category', label: '分类页', icon: 'fas fa-th-large' },
        { path: '/cart', label: '购物车', icon: 'fas fa-shopping-bag' },
        { path: '/user', label: '我的', icon: 'fas fa-user' }
      ]
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(path + '/')
    },
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    border-top: 1px solid #edf2f7;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 50px;
    z-index: 999;

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: #8e8e93;
      cursor: pointer;
      padding: 4px 12px;
      transition: color 0.2s;
      height: 100%;

      i {
        font-size: 22px;
        margin-bottom: 2px;
        color: #8e8e93;
        transition: color 0.2s;
      }

      span {
        font-size: 11px;
        letter-spacing: 0.2px;
      }

      &.active {
        color: #ff6b35;

        i {
          color: #ff6b35;
        }
      }

      &:hover {
        color: #ff6b35;

        i {
          color: #ff6b35;
        }
      }
    }
  }
}
</style>